<template>
    <div>
      <div
        v-if="loanProductsLoading"
        style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
      >
        <div>
          <div>
            <h3>Getting Loans ready...</h3>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="mb-2 font-regular">Completed Loans</h1>
      </div>
      <!-- <loan-stat /> -->
      <div>
        <div class="col-md-12">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Filter Loan Report</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="">BVN</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="bvn"
                        placeholder="11111111111"
                        maxlength="11"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="">phone</label>
                      <input
                        type="text"
                        @keypress="isNumber($event)"
                        class="form-control"
                        v-model="phone"
                        placeholder="08012345678"
                        maxlength="13"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="">Reference</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="83IJDK2DHEU"
                        v-model="ref"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <button
                      @click.prevent="allProductLoan(1)"
                      class="button w-100 mt-2"
                      :disabled="reportsLoading"
                    >
                      <span class="custom-loader" v-if="reportsLoading">
                        <loader-icon
                          size="1.5x"
                          class="custom-class"
                        ></loader-icon>
                        <span style="font-weight: 600; text-transform: initial;"
                          >Fetching Loan Data...</span
                        >
                      </span>
                      <span v-else>
                        Filter
                      </span>
                    </button>
                    <!-- </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <loan-table 
          v-if="!loanProductsLoading"
          :loanProducts = "loanProducts"
          @onPageChangeAction = "onPageChange"
          :current = "current"
          :total = "total"
        />
      </div>
    </div>
  </template>
  
  <script>
  import VueDataTable from "@/components/VueDataTable";
  // import { mapGetters } from "vuex";
  import CCard from "@/components/CCard";
  import KeyValue from "../../components/KeyValue.vue";
  import CModal from "@/components/CModal";
  import CDataTable from "../../components/CDataTable.vue";
  import ApiService from "@/services/api.service";
  // import Swal from "sweetalert2";
  // import ErrorService from "@/services/error.service";
  import CPagination from "../../components/CPagination.vue";
  // import { ClipboardIcon, CreditCardIcon } from "vue-feather-icons";
  // let currentTab = 0;
  
  
  export default {
    components: {
      VueDataTable,
      KeyValue,
      // ClipboardIcon,
      CCard,
      CModal,
      CDataTable,
      CPagination
      // CreditCardIcon
    },
    computed: {
      permissions() {
        let permissions = this.$store.getters.permissions;
        return permissions;
      },
      // ...mapGetters(["reportsLoading"]),
      removeCommaFromAmount() {
        return this.loan_amount.toString().replace(/,/g, "");
      }
    },
    data() {
      return {
        loanProductsLoading: true,
        loanProducts: [],
        end_date: "",
        start_date: "",
        customer_id: "",
        next_page: 1,
        total: 1,
        current: 1,
        reference: "",
        bvn: "",
        phone: "",
        ref: "",
        status: "",
        reportsLoading: true,
        kpiObj: null,
        kpiLoading: false
      };
    },
    methods: {
      isNumber: function(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      async allProductLoan(page) {
        this.reportsLoading = true;
  
        try {
          const response = await ApiService.get(
            `loan/instant/all?page=${page}&instant_reference=${this.ref}&phone=${this.phone}&bvn=${this.bvn}&loan_status=completed&bypass=yes`
          );
          console.log(response);
          this.loanProducts = response.data.data.data;
          this.current = response.data.data.current_page;
          this.total = response.data.data.last_page;
          this.loanProductsLoading = false;
          this.reportsLoading = false;
        } catch (error) {
          console.log(error.response);
          this.loanProductsLoading = false;
          this.reportsLoading = false;
        } finally {
          this.loanProductsLoading = false;
          this.reportsLoading = false;
        }
      },
      onPageChange(nextp) {
        console.log(nextp + 'main component');
        if (this.current != nextp) {
          this.allProductLoan(nextp);
        }
      }
    },
    mounted() {
      this.allProductLoan(1);
      // this.kpiStats();
    }
  };
  </script>
  
  <style>
  /* Hide all steps by default: */
  .step-panel {
    display: none;
  }
  </style>
  